{
  "route": "earth3",
  "railEntries": [
    {
      "label": "Premise",
      "anchor": "earth3-premise"
    },
    {
      "label": "Architecture",
      "anchor": "earth3-architecture"
    },
    {
      "label": "Commons",
      "anchor": "earth3-commons"
    },
    {
      "label": "Decisions",
      "anchor": "earth3-decisions"
    },
    {
      "label": "Proof",
      "anchor": "earth3-proof"
    }
  ],
  "anchors": [
    "earth3-premise",
    "earth3-title",
    "earth3-definition",
    "earth3-integration",
    "earth3-architecture",
    "earth3-commons",
    "earth3-spine",
    "earth3-principles",
    "earth3-decisions",
    "earth3-stress-test",
    "earth3-proof"
  ],
  "nodes": [
    {
      "tag": "section",
      "attrs": {
        "class": "route chapter earth3-chapter active",
        "id": "route-earth3",
        "aria-labelledby": "earth3-title"
      },
      "children": [
        {
          "tag": "div",
          "attrs": {
            "class": "wrap"
          },
          "children": [
            {
              "tag": "header",
              "attrs": {
                "class": "earth3-overview",
                "id": "earth3-premise"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "earth3-copy"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "chapter-index"
                      },
                      "children": [
                        "04 / The Third Way"
                      ]
                    },
                    " ",
                    {
                      "tag": "h1",
                      "attrs": {
                        "id": "earth3-title"
                      },
                      "children": [
                        "Earth 3.0"
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "earth3-tagline"
                      },
                      "children": [
                        "Govern change before, through and beyond disruption."
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "earth3-deck"
                      },
                      "children": [
                        "A place-based, rights-aware operating model for protecting what must endure, retiring what no longer serves and growing what comes next."
                      ]
                    },
                    " ",
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "earth3-rule",
                        "aria-hidden": "true"
                      },
                      "children": []
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "earth3-conditions"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "children": [
                            "Built for uncertainty"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Governed by safe-and-just limits"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Designed to leave capability behind"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "hero-actions"
                      },
                      "children": [
                        {
                          "tag": "button",
                          "attrs": {
                            "class": "e3-button primary",
                            "type": "button",
                            "data-scroll-to": "earth3-architecture"
                          },
                          "children": [
                            "Explore the model ",
                            {
                              "tag": "span",
                              "attrs": {
                                "aria-hidden": "true"
                              },
                              "children": [
                                "→"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "button",
                          "attrs": {
                            "class": "e3-button",
                            "type": "button",
                            "data-route": "sources"
                          },
                          "children": [
                            "View the evidence ",
                            {
                              "tag": "span",
                              "attrs": {
                                "aria-hidden": "true"
                              },
                              "children": [
                                "→"
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "living-model",
                    "aria-labelledby": "model-title",
                    "aria-describedby": "model-description model-summary"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-caption"
                      },
                      "children": [
                        {
                          "tag": "strong",
                          "attrs": {
                            "id": "model-title"
                          },
                          "children": [
                            "The Living Crossing"
                          ]
                        },
                        {
                          "tag": "span",
                          "attrs": {
                            "id": "model-description"
                          },
                          "children": [
                            "A governed system for continuity, transition and regeneration."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "visually-hidden",
                        "id": "model-summary"
                      },
                      "children": [
                        "Bound defines the safe-and-just limits. See senses the living system in context. Hold protects what must endure, Cross retires what no longer serves, and Grow cultivates what comes next. Choose brings decisions into a transition commons. Shift coordinates action across scales and Learn closes the feedback loop."
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node bound"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Bound"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Safe-and-just limits"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node see"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "See"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Sense the living system in context."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node hold"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Hold"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Protect what must endure."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node choose"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Choose"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Transition commons"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node grow"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Grow"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Cultivate what comes next."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node cross"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Cross"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Retire what no longer serves."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node shift"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Shift"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Coordinate action across scales."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "model-node learn"
                      },
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Learn"
                          ]
                        },
                        {
                          "tag": "small",
                          "children": [
                            "Close the loop. Improve the model."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "model-callout right-one"
                      },
                      "children": [
                        "Decision commons where values, evidence and rights converge."
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "model-callout right-two"
                      },
                      "children": [
                        "Execution with accountability and adaptive feedback."
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "spine-ribbon",
                "aria-label": "Earth 3.0 operating spine"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "spine-intro"
                  },
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Operating spine"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "A continuous cycle that holds the crossing and compounds capability over time."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "spine-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "spine-icon",
                        "aria-hidden": "true"
                      },
                      "children": [
                        "◎"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Bound"
                          ]
                        },
                        "Define the safe-and-just limits."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "spine-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "spine-icon",
                        "aria-hidden": "true"
                      },
                      "children": [
                        "⠿"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "See"
                          ]
                        },
                        "Sense the living system in context."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "spine-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "spine-icon",
                        "aria-hidden": "true"
                      },
                      "children": [
                        "◇"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Choose"
                          ]
                        },
                        "Decide in the transition commons."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "spine-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "spine-icon",
                        "aria-hidden": "true"
                      },
                      "children": [
                        "→"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Shift"
                          ]
                        },
                        "Act with coordination and care."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "spine-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "spine-icon",
                        "aria-hidden": "true"
                      },
                      "children": [
                        "↻"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        {
                          "tag": "b",
                          "children": [
                            "Learn"
                          ]
                        },
                        "Reflect, adapt and improve."
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "chapter-body"
              },
              "children": [
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-definition"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "quote-panel"
                      },
                      "children": [
                        {
                          "tag": "blockquote",
                          "children": [
                            {
                              "tag": "em",
                              "children": [
                                "Earth 3.0"
                              ]
                            },
                            " is place-based, rights-aware and shock-capable infrastructure that helps a system protect what must endure, retire what causes harm and grow what comes next across every phase: before, through and after disruption."
                          ]
                        },
                        {
                          "tag": "cite",
                          "children": [
                            "Working definition · synthesis v0.1"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-integration"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The higher integration"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "A model built around ",
                            {
                              "tag": "em",
                              "children": [
                                "uncertainty, not a forecast."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "lead"
                      },
                      "children": [
                        "The likeliest operating reality is mixed: falling technology costs, institutional strain, ecological shocks, local renewal and capture all occurring at once. Earth 3.0 makes the transition portfolio robust across that whole field."
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "axiom-list"
                      },
                      "children": [
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "01"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Abundance is possibility, not promise."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "02"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Collapse is condition, not destiny."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "03"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Technology is a lever, not an organising system."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "04"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Resilience without justice protects the wrong things."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "05"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Participation without power is theatre."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "06"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "A prototype without transfer is the pilot trap."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-architecture"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The temporal portfolio"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Hold what matters. Cross what must change. ",
                            {
                              "tag": "em",
                              "children": [
                                "Grow what comes next."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "horizon-grid"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "horizon"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "verb"
                              },
                              "children": [
                                "HOLD · H1"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Protect & hospice"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Keep essential systems functioning, reduce present harm and retire failures with dignity rather than denial."
                              ]
                            },
                            {
                              "tag": "ul",
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Continuity of essentials"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Immediate harm reduction"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Just transition for people affected"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Managed sunset and memory"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "horizon"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "verb"
                              },
                              "children": [
                                "CROSS · H2"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Redirect & bridge"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Move authority, money, assets and capability while testing a portfolio of transition pathways."
                              ]
                            },
                            {
                              "tag": "ul",
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Shared mandate and charter"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Power and resource transfer"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Demonstration portfolio"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Learning and decision gates"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "horizon"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "verb"
                              },
                              "children": [
                                "GROW · H3"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Nurture & distribute"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Protect regenerative alternatives long enough to mature, then spread capability without creating dependency."
                              ]
                            },
                            {
                              "tag": "ul",
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Distributed local capacity"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Safe and just outcomes"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "New ownership and value flows"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Adaptive replication"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "footnote"
                      },
                      "children": [
                        "This temporal frame draws on Three Horizons, Berkana’s Two Loops and transition management’s X-curve, while adding explicit shock operations, rights and portfolio governance. ",
                        {
                          "tag": "a",
                          "attrs": {
                            "class": "source-link",
                            "href": "https://www.internationalfuturesforum.com/three-horizons",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "[S11]"
                          ]
                        },
                        " ",
                        {
                          "tag": "a",
                          "attrs": {
                            "class": "source-link",
                            "href": "https://berkana.org/our-work/pioneering-a-new-paradigm/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "[S12]"
                          ]
                        },
                        " ",
                        {
                          "tag": "a",
                          "attrs": {
                            "class": "source-link",
                            "href": "https://drift.eur.nl/en/publications/toolkit/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "[S25]"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-commons"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The operating unit"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "A Transition Commons, not another ",
                            {
                              "tag": "em",
                              "children": [
                                "stakeholder table."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid three"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Container"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Transition Commons"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "A place-based, time-bounded governance container with delegated authority, participant resourcing and rules that survive personalities."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Physics"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "The Threshold"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The readiness and movement logic: when to pause, build conditions, cross, stay or stop."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Steward"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Systems Transition Broker"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "You read readiness, compose authority and transfer the system’s capacity back to itself."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label"
                              },
                              "children": [
                                "Guardrail"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Safe & Just Corridor"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Social floors, ecological ceilings and distributional justice constrain every option. ",
                                {
                                  "tag": "a",
                                  "attrs": {
                                    "class": "source-link",
                                    "href": "https://earthcommission.org/safe-and-just-earth-system-boundaries/",
                                    "target": "_blank",
                                    "rel": "noreferrer"
                                  },
                                  "children": [
                                    "[S09]"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label"
                              },
                              "children": [
                                "Portfolio"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Three Horizons"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Resources flow across continuity, transition and emergence instead of betting everything on one heroic project."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label"
                              },
                              "children": [
                                "Accountability"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Living Evidence"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Facts, uncertainty, values and lived knowledge remain visible; decisions and consequences are traceable."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-spine"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The operating spine"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Bound. See. Choose. Shift. ",
                            {
                              "tag": "em",
                              "children": [
                                "Learn."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "ol",
                      "attrs": {
                        "class": "number-list"
                      },
                      "children": [
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Bound"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Set the safe-and-just corridor, rights, non-negotiables and unacceptable harms before generating options."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "See"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Build shared situational awareness from verified evidence, plural knowledge, power analysis and explicit uncertainty."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Choose"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Use legitimate deliberation and declared decision rules to make trade-offs, allocate authority and select a portfolio."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Shift"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Protect, phase out, repair and build through coordinated action across the three horizons."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Learn"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Track outcomes and distribution, publish consequences and revise through pre-agreed triggers."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "footnote"
                      },
                      "children": [
                        "This is Earth 3.0’s distinct operating spine. It preserves your Sense · Design · Shift · Stay while making boundaries, legitimate choice and revision explicit."
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-principles"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Constitutional principles"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Eight rules that make the room ",
                            {
                              "tag": "em",
                              "children": [
                                "real."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "ol",
                      "attrs": {
                        "class": "number-list"
                      },
                      "children": [
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Hold multiple futures"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "No single abundance or collapse forecast may control the architecture."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Stay inside the corridor"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Options must be ecologically safe, socially just and explicit about trade-offs."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Rights before representation"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "First Peoples participate through their own governance as rights-holders, not as an additional “stakeholder seat.”"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Engineer power"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Name decision rights, consent, veto, compensation, conflicts, liability and appeal."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Build portfolios"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Test multiple connected interventions; fund learning, not only delivery."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Operate through shocks"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Pre-agree continuity, rapid decision and public communication protocols."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Use plural evidence"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Distinguish verified fact, uncertainty, values, interests and Indigenous data governance."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Transfer capacity"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Success means local stewardship can continue without the original broker."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-decisions"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Readiness gates"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Readiness is not a score. It is a ",
                            {
                              "tag": "em",
                              "children": [
                                "governance decision with stop rules."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "gate-grid"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "gate stop"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Stop"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Do not convene the theatre."
                              ]
                            },
                            {
                              "tag": "ul",
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Rights-holders have not authorised participation"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "The outcome is predetermined"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Evidence cannot be shared"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "A funder controls the answer"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "No accountable authority exists"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Affected participation is unfunded"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "gate build"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Build readiness"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The need is real; conditions are incomplete."
                              ]
                            },
                            {
                              "tag": "ul",
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Resource community participation"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Repair representation gaps"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Map authority and constraints"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Develop a common evidence base"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Secure transition runway"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Clarify rights and data protocols"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "gate cross"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Cross"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Move into a bounded demonstrator."
                              ]
                            },
                            {
                              "tag": "ul",
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Need and authority are acknowledged"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Rights and consent are explicit"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Resources match the work"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Decision rules are chartered"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Outcome guardrails are measurable"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Exit and learning are designed"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-stress-test"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Stress test"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "One architecture. Three ",
                            {
                              "tag": "em",
                              "children": [
                                "very different worlds."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "scenario-scroll"
                      },
                      "children": [
                        {
                          "tag": "table",
                          "attrs": {
                            "class": "scenario-table"
                          },
                          "children": [
                            {
                              "tag": "caption",
                              "attrs": {
                                "class": "visually-hidden"
                              },
                              "children": [
                                "Earth 3.0 stress test across three possible futures"
                              ]
                            },
                            " ",
                            {
                              "tag": "thead",
                              "children": [
                                {
                                  "tag": "tr",
                                  "children": [
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "col"
                                      },
                                      "children": [
                                        "Test"
                                      ]
                                    },
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "col"
                                      },
                                      "children": [
                                        "Stellar breakthrough"
                                      ]
                                    },
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "col"
                                      },
                                      "children": [
                                        "Cascading disruption"
                                      ]
                                    },
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "col"
                                      },
                                      "children": [
                                        "Uneven hybrid"
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tbody",
                              "children": [
                                {
                                  "tag": "tr",
                                  "children": [
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "row"
                                      },
                                      "children": [
                                        "Protect"
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Prevent capture; guarantee broad access and ecological boundaries."
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Maintain food, care, shelter, energy and legitimate public authority."
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Shield exposed places and workers from unequal transition costs."
                                      ]
                                    }
                                  ]
                                },
                                " ",
                                {
                                  "tag": "tr",
                                  "children": [
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "row"
                                      },
                                      "children": [
                                        "Redirect"
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Move surplus into shared capability, ownership and restoration."
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Use rapid authority and pooled resources without suspending rights."
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Sequence infrastructure, capital and regulation across different speeds."
                                      ]
                                    }
                                  ]
                                },
                                " ",
                                {
                                  "tag": "tr",
                                  "children": [
                                    {
                                      "tag": "th",
                                      "attrs": {
                                        "scope": "row"
                                      },
                                      "children": [
                                        "Learn"
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Track concentration, rebound effects and new dependencies."
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Preserve options, local knowledge and recovery capability."
                                      ]
                                    },
                                    {
                                      "tag": "td",
                                      "children": [
                                        "Compare portfolios; expand only what remains safe, just and adaptive."
                                      ]
                                    }
                                  ]
                                },
                                " "
                              ]
                            },
                            " "
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth3-proof"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Proof standard"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Measure the transition, not the ",
                            {
                              "tag": "em",
                              "children": [
                                "volume of activity."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid four"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Mandate"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Who has legitimate authority, and does it deepen rather than narrow?"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Distribution"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Who gains, who carries cost, and where power, assets and value move."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Resilience"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Whether essentials, relationships and options hold through disruption."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "Regeneration"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Whether ecological and social conditions measurably improve over time."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "button",
                  "attrs": {
                    "class": "route-next",
                    "type": "button",
                    "data-go": "practice"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Make it land"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "The Practice · Consultancy & PR →"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "footer",
                  "attrs": {
                    "class": "tiny-footer"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "04 · Earth 3.0"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Adaptive transition infrastructure"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " "
      ]
    },
    " "
  ]
}
